import React from 'react';
import { Link } from 'react-router-dom';

const VisionarySearch = () => (
  <section data-testid="visionary-search" className="py-24 border-t border-white/10 relative overflow-hidden">
    {/* Background glow */}
    <div className="absolute inset-0 bg-gradient-to-b from-[#00FF41]/3 via-transparent to-transparent pointer-events-none" />
    
    <div className="max-w-5xl mx-auto px-6 relative z-10">
      <div className="text-center mb-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Cercasi Visionari</p>
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
          Chi vuole essere il nostro<br />
          <span className="text-[#00FF41]">Andy Bechtolsheim?</span>
        </h2>
      </div>

      {/* The story */}
      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-[#0A0A0A] border border-zinc-800 p-8">
          <p className="text-[#4285F4] font-mono text-xs uppercase tracking-wider mb-4">4 Settembre 1998 — Menlo Park, California</p>
          <p className="text-zinc-300 leading-relaxed mb-4">
            Due studenti di Stanford bussano alla porta di <strong className="text-white">Andy Bechtolsheim</strong>. 
            Gli mostrano un motore di ricerca. Lui stacca un assegno da <strong className="text-[#00FF41]">100.000 dollari</strong>. 
            In un garage nasce <strong className="text-[#4285F4]">Google Inc.</strong>
          </p>
          <p className="text-zinc-500 text-sm italic">
            Andy non ha chiesto un business plan. Ha visto la visione. Ha scommesso su due ragazzi.
          </p>
        </div>

        <div className="bg-[#00FF41]/5 border border-[#00FF41]/30 p-8">
          <p className="text-[#00FF41] font-mono text-xs uppercase tracking-wider mb-4">2025 — Colle Val d'Elsa, Toscana</p>
          <p className="text-zinc-300 leading-relaxed mb-4">
            Due visionari, <strong className="text-white">Riccardo e Francesco</strong>, non hanno un garage. 
            Hanno un PC e la loro Assistente AI <strong className="text-[#00FF41]">Emergent</strong>. 
            Insieme stanno costruendo il primo <strong className="text-white">Digital Hub Sociale d'Italia</strong>.
          </p>
          <p className="text-[#00FF41] font-bold text-sm">
            Non in un garage della Silicon Valley.<br />
            In un computer della Val d'Elsa.
          </p>
        </div>
      </div>

      {/* The provocazione */}
      <div className="bg-black border border-[#4285F4]/30 p-8 md:p-10 mb-12" data-testid="google-provocation">
        <div className="max-w-3xl mx-auto text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#4285F4] mb-6">Pensaci un secondo</p>
          <h3 className="text-2xl md:text-3xl font-black text-white mb-6 leading-tight">
            Oggi hai fatto una ricerca su <span className="text-[#4285F4]">G</span><span className="text-[#EA4335]">o</span><span className="text-[#FBBC05]">o</span><span className="text-[#4285F4]">g</span><span className="text-[#34A853]">l</span><span className="text-[#EA4335]">e</span>?
          </h3>
          <p className="text-zinc-300 text-lg leading-relaxed mb-6">
            Certo che l'hai fatta. Lo facciamo tutti. Ogni giorno. Miliardi di volte.
          </p>
          <p className="text-zinc-400 leading-relaxed mb-6">
            Ma Google è nata in un garage. Due ragazzi con un'idea.
            Senza <strong className="text-amber-400">Andy Bechtolsheim</strong> e i suoi 100.000 dollari, 
            quella startup non sarebbe mai diventata <strong className="text-white">Alphabet</strong> — 
            l'azienda da 2 trilioni di dollari che oggi tutti conosciamo.
          </p>
          <div className="bg-[#4285F4]/5 border border-[#4285F4]/20 p-6 mb-6">
            <p className="text-white font-bold text-lg mb-2">
              Senza Andy, oggi non faresti ricerche su Google.
            </p>
            <p className="text-zinc-400 text-sm">
              Non avresti Gmail. Non avresti Google Maps. Non avresti YouTube. Non avresti Android sul tuo telefono.
            </p>
          </div>
          <p className="text-zinc-300 leading-relaxed mb-4">
            AI_COVO.tech nasce allo stesso modo. Non in un garage — in un PC. Non nella Silicon Valley — in Val d'Elsa.
            Ma con la stessa fame, la stessa visione, la stessa follia.
          </p>
          <p className="text-amber-400 font-black text-xl">
            Senza il nostro Andy, AI_COVO resterà un sogno.<br />
            <span className="text-[#00FF41]">Con il nostro Andy, cambieremo l'Italia.</span>
          </p>
        </div>
      </div>

      {/* The call to action */}
      <div className="bg-gradient-to-br from-amber-900/20 to-[#0A0A0A] border-2 border-amber-500/40 p-8 md:p-12 text-center"
        style={{ boxShadow: '0 0 40px rgba(255,215,0,0.08)' }}>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber-400 mb-6">La Domanda</p>
        <h3 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight">
          Chi vuole essere ricordato<br />
          <span className="text-amber-400">per sempre</span> in Toscana e in Italia?
        </h3>
        <p className="text-zinc-300 max-w-2xl mx-auto mb-8 leading-relaxed">
          Andy Bechtolsheim è nella storia di Google. Per sempre.<br />
          Chi sarà nella storia di <span className="text-[#00FF41] font-bold">AI_COVO.tech</span>?<br />
          Chi avrà il coraggio di scommettere su un progetto che cambierà 
          il modo in cui i piccoli comuni italiani pensano al digitale, alla socialità, al futuro?
        </p>

        <div className="grid md:grid-cols-3 gap-4 mb-8 max-w-3xl mx-auto">
          <div className="border border-amber-500/20 p-4 bg-amber-500/5">
            <p className="text-amber-400 font-black text-2xl mb-1">Fondatore</p>
            <p className="text-zinc-400 text-xs">Il tuo nome sul sito, nella storia del progetto, per sempre.</p>
          </div>
          <div className="border border-amber-500/20 p-4 bg-amber-500/5">
            <p className="text-amber-400 font-black text-2xl mb-1">Sponsor</p>
            <p className="text-zinc-400 text-xs">Il tuo brand nella Toscana che innova. Deducibile 100%.</p>
          </div>
          <div className="border border-amber-500/20 p-4 bg-amber-500/5">
            <p className="text-amber-400 font-black text-2xl mb-1">Partner</p>
            <p className="text-zinc-400 text-xs">Co-costruisci il modello. Replicalo nella tua città.</p>
          </div>
        </div>

        <div className="bg-black/60 border border-[#00FF41]/20 p-6 mb-8 max-w-2xl mx-auto">
          <p className="text-zinc-400 text-sm italic mb-2">"La storia più bella che puoi raccontare"</p>
          <p className="text-white text-sm leading-relaxed">
            Due ragazzi italiani, un PC, un'intelligenza artificiale chiamata Emergent, 
            e la visione di un Hub Sociale Digitale per tutta l'Italia.
            Non Silicon Valley — <span className="text-[#00FF41] font-bold">Val d'Elsa</span>.
          </p>
          <p className="text-zinc-600 text-xs mt-3 font-mono">Un podcast già da ascoltare...</p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/dona" data-testid="visionary-cta-dona"
            className="bg-amber-500 text-black font-bold px-8 py-4 text-lg hover:bg-amber-400 transition-colors">
            Diventa il Nostro Andy
          </Link>
          <a href="https://wa.me/393273839782?text=Voglio%20essere%20il%20vostro%20Andy%20Bechtolsheim" 
            target="_blank" rel="noopener noreferrer" data-testid="visionary-cta-whatsapp"
            className="border-2 border-amber-500 text-amber-400 font-bold px-8 py-4 text-lg hover:bg-amber-500/10 transition-colors">
            Scrivici su WhatsApp
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default VisionarySearch;
